/**
 * IMPORTANT
 * Brand comparisons are synced into `src/client-content/` via:
 * - `pnpm sync:client-content`
 */

import type {
  BrandComparison as ClientBrandComparison,
} from '@/client-content/(browse)/brands/compare/_lib/comparison-data'
import {
  comparisons as clientComparisons,
  getComparisonBySlug as getClientComparisonBySlug,
  getAllComparisonSlugs as getClientAllComparisonSlugs,
} from '@/client-content/(browse)/brands/compare/_lib/comparison-data'

export type BrandComparison = ClientBrandComparison

export function getComparisons(): BrandComparison[] {
  return clientComparisons
}

export function getComparisonBySlug(slug: string): BrandComparison | undefined {
  return getClientComparisonBySlug(slug)
}

export function getAllComparisonSlugs(): string[] {
  return getClientAllComparisonSlugs()
}

export function getComparisonPageCounts(): {
  hub: number
  comparisons: number
  total: number
} {
  const hub = 1
  const comparisons = clientComparisons.length
  return { hub, comparisons, total: hub + comparisons }
}

